import AxiosInstance from 'utils/AxiosInstance'
import {
  RESET_FORM_FIELDS,
  RESET_SELECTED_ITEMS,
  SET_ASSIGN_SEARCH_VALUE,
  SET_ASSIGNED_FORMS,
  SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION,
  SET_CURRENT_ITEMS,
  SET_CURRENT_SELECTED_ITEMS,
  SET_CURRENT_SHOW_SELECTED_ITEMS,
  SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION,
  SET_CURRENT_TAB,
  SET_CURRENT_TOGGLE_ITEM_FUNCTION,
  SET_FILES,
  SET_FILL_FORM_MODAL_DATA,
  SET_FORM_SECTIONS,
  SET_FORM_SUBMISSION_ID,
  SET_FORMS,
  SET_LOADING_FORMS,
  SET_NEW_FORM_FIELDS,
  SET_SELECTED_END_DATE,
  SET_SELECTED_LOCATION,
  SET_SELECTED_LOCATION_GROUPS,
  SET_SELECTED_LOCATIONS,
  SET_SELECTED_ORG_GROUPS,
  SET_SELECTED_ROLE_GROUPS,
  SET_SELECTED_ROLES,
  SET_SELECTED_ROLES_FILTER,
  SET_SELECTED_START_DATE,
  SET_SELECTED_STATUS,
  SET_SELECTED_STORES,
  SET_SELECTED_USERS,
  SET_SHOW_FORM_SUBMISSION,
  SET_SHOW_SELECTED_LOCATION_GROUPS,
  SET_SHOW_SELECTED_LOCATIONS,
  SET_SHOW_SELECTED_ORG_GROUPS,
  SET_SHOW_SELECTED_ROLES,
  SET_SHOW_SELECTED_STORES,
  SET_SHOW_SELECTED_USERS,
  SET_SHOW_SELECTED_USERS_ITEMS,
  SET_SUBMISSION,
  SET_SUBMISSION_MODAL_DATA,
  SET_USER_STORES,
  TOGGLE_MODAL,
} from './constants'

export const setNewFormFields = (data) => ({
  type: SET_NEW_FORM_FIELDS,
  payload: data,
})

export const createForm = (title) => {
  return (dispatch, getState) => {
    const { newFormFields, files } = getState().form

    const formData = new FormData()
    formData.append('title', title)
    formData.append('form_data', JSON.stringify(newFormFields))

    // Append files if any admin-attached files exist
    files.forEach((file) => {
      const finalFile = file[0] ? file[0] : file.file
      formData.append('files', finalFile)
      formData.append('fieldIndexes', file.fieldIndex)
    })

    AxiosInstance.post(`/forms`, formData).then(() => {
      dispatch(fetchForms())
      dispatch(fetchAssignedForms())
      dispatch(resetFiles()) // Clear files after successful form creation
    })
  }
}

export const deleteForm = (id) => {
  return (dispatch, getState) => {
    const { forms } = getState().form
    AxiosInstance.delete(`/forms/${id}`).then(() => {
      const newFormsArr =
        forms && forms.length ? forms.filter((form) => form.id !== id) : []
      dispatch({ type: SET_FORMS, payload: newFormsArr })
    })
  }
}

export const submitForm = (formId, selectedStores = []) => {
  return (dispatch, getState) => {
    const { newFormFields, files } = getState().form

    const formData = new FormData()
    formData.append('form_data', JSON.stringify(newFormFields))
    formData.append('stores', JSON.stringify(selectedStores))

    files.forEach((file) => {
      const finalFile = file[0] ? file[0] : file.file
      formData.append('files', finalFile)
      formData.append('fieldIndexes', file.fieldIndex)
    })

    return AxiosInstance.put(`/forms/submit/${formId}`, formData).then(() => {
      dispatch(fetchAssignedForms())
    })
  }
}

export const setFiles = (newFile) => {
  return (dispatch, getState) => {
    const { files } = getState().form

    // Remove any existing file for this field and add the new one
    const filteredFiles = files.filter(
      (file) => file.fieldIndex !== newFile.fieldIndex
    )
    dispatch({ type: SET_FILES, payload: [...filteredFiles, newFile] })
  }
}

export const resetFiles = () => ({ type: SET_FILES, payload: [] })

export const setSelectedStatus = (status) => ({
  type: SET_SELECTED_STATUS,
  payload: status,
})

export const setSelectedLocation = (location) => ({
  type: SET_SELECTED_LOCATION,
  payload: location,
})

export const setSelectedStartDate = (date) => ({
  type: SET_SELECTED_START_DATE,
  payload: date,
})

export const setSelectedEndDate = (date) => ({
  type: SET_SELECTED_END_DATE,
  payload: date,
})

export const fetchSubmission = (submissionId, userId) => {
  return (dispatch, getState) => {
    AxiosInstance.get(
      `/forms/submission/${submissionId}${userId ? `?userId=${userId}` : ''}`
    ).then((data) => {
      const formData = JSON.parse(data.submission.form_data)

      dispatch({
        type: SET_NEW_FORM_FIELDS,
        payload: formData,
      })
      dispatch({ type: SET_SUBMISSION, payload: data.status })
      dispatch({ type: SET_FILES, payload: data.files })
    })
  }
}

export const fetchUserStores = (userId = '') => {
  return (dispatch, getState) => {
    AxiosInstance.get(
      `/forms/stores${userId ? `?user_id=${userId}` : ''}`
    ).then((data) => {
      dispatch({ type: SET_USER_STORES, payload: data })
    })
  }
}

export const updateSubmission = (submissionId, data) => {
  return (dispatch, getState) => {
    AxiosInstance.put(`/forms/submission/${submissionId}`, data).then(() => {})
  }
}

export const createComment = (submissionId, comment) => {
  return (dispatch, getState) => {
    AxiosInstance.post(`/forms/submission/${submissionId}`, { comment }).then(
      () => {}
    )
  }
}

export const deleteSubmission = (id) => {
  return (dispatch, getState) => {
    // eslint-disable-next-line
    if (!confirm('Are you sure you want to remove this form submission?')) {
      return
    }

    AxiosInstance.delete(`/forms/submission/${id}`).then(() => {})
  }
}

export const assignFormUsers = (formId) => {
  return (dispatch, getState) => {
    const {
      selectedOrgGroups,
      selectedLocationGroups,
      selectedLocations,
      selectedRoles,
      selectedUsers,
      selectedStores,
    } = getState().form

    if (
      !selectedOrgGroups.length &&
      !selectedLocationGroups.length &&
      !selectedRoles.length &&
      !selectedUsers.length &&
      !selectedStores.length
    ) {
      alert('Please choose a recipent!')
      return
    }

    const data = {
      groups: [...selectedOrgGroups, ...selectedLocationGroups],
      users: selectedUsers,
      stores: selectedStores,
      roles: selectedRoles,
    }

    return AxiosInstance.post(`/forms/users/${formId}`, data).then(() => {})
  }
}

export const fetchForms = () => {
  return (dispatch, getState) => {
    dispatch({ type: SET_LOADING_FORMS, payload: true })
    AxiosInstance.get(`/forms`).then((data) => {
      dispatch({ type: SET_FORMS, payload: data })
      dispatch({ type: SET_LOADING_FORMS, payload: false })
    })
  }
}

export const fetchAssignedForms = () => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/forms/assigned`).then((data) => {
      dispatch({ type: SET_ASSIGNED_FORMS, payload: data })
    })
  }
}

export const fetchAssignedItems = (id) => {
  return (dispatch, getState) => {
    const { groups } = getState().groups
    const orgGroups = []
    const locationGroups = []
    const roleGroups = []
    const locations = []
    const stores = []
    const users = []
    const roles = []
    AxiosInstance.get(`/forms/assignees/${id}`).then((data) => {
      if (data && data.length) {
        data.map((item) => {
          switch (item.assignee) {
            case 'group':
              const currentGroup = groups.find(
                (groupItem) => groupItem.id === parseInt(item.assignee_id)
              )

              if (currentGroup && currentGroup.type === 'org') {
                return orgGroups.push(parseInt(item.assignee_id))
              } else if (currentGroup && currentGroup.type === 'location') {
                return locationGroups.push(parseInt(item.assignee_id))
              } else if (currentGroup && currentGroup.type === 'role') {
                return roleGroups.push(parseInt(item.assignee_id))
              }
            case 'store':
              return stores.push(parseInt(item.assignee_id))
            case 'role':
              return roles.push(parseInt(item.assignee_id))
            case 'user':
              return users.push(item.assignee_id)
          }
        })

        dispatch({ type: SET_SELECTED_ORG_GROUPS, orgGroups })
        dispatch({ type: SET_SELECTED_LOCATION_GROUPS, locationGroups })
        dispatch({ type: SET_SELECTED_ROLE_GROUPS, roleGroups })
        dispatch({ type: SET_SELECTED_LOCATIONS, locations })
        dispatch({ type: SET_SELECTED_STORES, stores })
        dispatch({ type: SET_SELECTED_USERS, users })
        dispatch({ type: SET_SELECTED_ROLES, roles })
      }
    })
  }
}

export const fetchForm = (formId) => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/forms/${formId}`).then((data) => {
      const formData = JSON.parse(data.form_data)

      dispatch({
        type: SET_NEW_FORM_FIELDS,
        payload: formData,
      })
    })
  }
}

export const updateForm = (formId) => {
  return (dispatch, getState) => {
    const { newFormFields, files } = getState().form

    const formData = new FormData()
    formData.append('form_data', JSON.stringify(newFormFields))

    // Append files if any admin-attached files exist
    files.forEach((file) => {
      const finalFile = file[0] ? file[0] : file.file
      formData.append('files', finalFile)
      formData.append('fieldIndexes', file.fieldIndex)
    })

    AxiosInstance.put(`/forms/${formId}`, formData)
  }
}

export const updateFormSettings = (formId, data) => {
  return (dispatch, getState) => {
    AxiosInstance.put(`/forms/${formId}`, data).then(() =>
      dispatch(fetchForms())
    )
  }
}

export const updateFormTitle = (formId, title) => {
  return (dispatch, getState) => {
    AxiosInstance.put(`/forms/${formId}`, { title })
  }
}

export const resetFormFields = () => (dispatch) => {
  dispatch({ type: RESET_FORM_FIELDS })
  dispatch(resetFiles()) // Also clear files when resetting form
}
export const resetSelectedItems = () => ({ type: RESET_SELECTED_ITEMS })

export const setAssignSearchValue = (assignSearchValue) => ({
  type: SET_ASSIGN_SEARCH_VALUE,
  assignSearchValue,
})
export const handleToggleModal = (modal) => {
  return (dispatch) => {
    if (modal === false) {
      dispatch(resetSelectedItems())
      dispatch(
        setCurrentTab(
          null,
          'category',
          'selectedOrgGroups',
          'groupOrgs',
          'toggleOrgGroups',
          'showSelectedOrgGroups',
          'setShowSelectedOrgGroups',
          'setHideSelectedOrgGroups'
        )
      )
      dispatch(setAssignSearchValue(''))
    }
    dispatch({
      type: TOGGLE_MODAL,
      payload: modal,
    })
  }
}
export const setCurrentTab = (
  event,
  currentTab,
  currentSelectedItems,
  currentItems,
  currentToggleFunction,
  currentShowSelectedItems,
  currentShowSelectedItemsFunction,
  currentHideSelectedItemsFunction
) => {
  return (dispatch) => {
    if (event !== null) {
      event.preventDefault()
    }
    dispatch({ type: SET_CURRENT_TAB, currentTab })
    dispatch({ type: SET_CURRENT_SELECTED_ITEMS, currentSelectedItems })
    dispatch({ type: SET_CURRENT_ITEMS, currentItems })
    dispatch({
      type: SET_CURRENT_TOGGLE_ITEM_FUNCTION,
      currentToggleFunction,
    })
    dispatch({
      type: SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION,
      currentHideSelectedItemsFunction,
    })
    dispatch({
      type: SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION,
      currentShowSelectedItemsFunction,
    })
    dispatch({
      type: SET_CURRENT_SHOW_SELECTED_ITEMS,
      currentShowSelectedItems,
    })
  }
}
export const toggleOrgGroups = (id) => {
  return (dispatch, getState) => {
    const { selectedOrgGroups } = getState().chat

    const index = selectedOrgGroups.indexOf(id)

    let orgGroups = []

    if (index !== -1) {
      orgGroups = [
        ...selectedOrgGroups.slice(0, index),
        ...selectedOrgGroups.slice(index + 1),
      ]
    } else {
      orgGroups = [...selectedOrgGroups, id]
    }

    dispatch({ type: SET_SELECTED_ORG_GROUPS, orgGroups })
  }
}
export const toggleUsers = (id) => {
  return (dispatch, getState) => {
    const { selectedUsers } = getState().chat

    const index = selectedUsers.indexOf(id)

    let users = []

    if (index !== -1) {
      users = [
        ...selectedUsers.slice(0, index),
        ...selectedUsers.slice(index + 1),
      ]
    } else {
      users = [...selectedUsers, id]
    }

    dispatch({ type: SET_SELECTED_USERS, users })
  }
}
export const toggleLocationGroups = (id) => {
  return (dispatch, getState) => {
    const { selectedLocationGroups } = getState().chat

    const index = selectedLocationGroups.indexOf(id)

    let locationGroups = []

    if (index !== -1) {
      locationGroups = [
        ...selectedLocationGroups.slice(0, index),
        ...selectedLocationGroups.slice(index + 1),
      ]
    } else {
      locationGroups = [...selectedLocationGroups, id]
    }

    dispatch({ type: SET_SELECTED_LOCATION_GROUPS, locationGroups })
  }
}
export const toggleLocations = (id) => {
  return (dispatch, getState) => {
    const { selectedLocations } = getState().chat

    const index = selectedLocations.indexOf(id)

    let locations = []

    if (index !== -1) {
      locations = [
        ...selectedLocations.slice(0, index),
        ...selectedLocations.slice(index + 1),
      ]
    } else {
      locations = [...selectedLocations, id]
    }

    dispatch({ type: SET_SELECTED_LOCATIONS, locations })
  }
}
export const toggleStores = (id) => {
  return (dispatch, getState) => {
    const { selectedStores } = getState().chat

    const index = selectedStores.indexOf(id)

    let stores = []

    if (index !== -1) {
      stores = [
        ...selectedStores.slice(0, index),
        ...selectedStores.slice(index + 1),
      ]
    } else {
      stores = [...selectedStores, id]
    }

    dispatch({ type: SET_SELECTED_STORES, stores })
  }
}
export const setRolesFilter = (value) => ({
  type: SET_SELECTED_ROLES_FILTER,
  value,
})
export const toggleRoles = (id) => {
  return (dispatch, getState) => {
    const { selectedRoles } = getState().chat

    const index = selectedRoles.indexOf(id)

    let roles = []

    if (index !== -1) {
      roles = [
        ...selectedRoles.slice(0, index),
        ...selectedRoles.slice(index + 1),
      ]
    } else {
      roles = [...selectedRoles, id]
    }

    dispatch({ type: SET_SELECTED_ROLES, roles })
  }
}

export const getFormSections = () => {
  return (dispatch, getState) => {
    AxiosInstance.post('/forms/sections').then((data) =>
      dispatch({ type: SET_FORM_SECTIONS, payload: data })
    )
  }
}

export const createFormSection = () => {
  return (dispatch, getState) => {
    AxiosInstance.post('/forms/sections', { title: 'Leart Section' }).then(
      () => {}
    )
  }
}

export const setShowSelectedOrgGroups = () => ({
  type: SET_SHOW_SELECTED_ORG_GROUPS,
  showSelectedOrgGroups: true,
})
export const setShowSelectedUsers = () => ({
  type: SET_SHOW_SELECTED_USERS,
  showSelectedUsers: true,
})
export const setHideSelectedUsers = () => ({
  type: SET_SHOW_SELECTED_USERS,
  showSelectedUsers: false,
})
export const setShowSelectedUsersItems = () => ({
  type: SET_SHOW_SELECTED_USERS_ITEMS,
  showSelectedUsersItems: true,
})
export const setHideSelectedUsersItems = () => ({
  type: SET_SHOW_SELECTED_USERS_ITEMS,
  showSelectedUsersItems: false,
})
export const setShowSelectedLocations = () => ({
  type: SET_SHOW_SELECTED_LOCATIONS,
  showSelectedLocations: true,
})
export const setHideSelectedLocations = () => ({
  type: SET_SHOW_SELECTED_LOCATIONS,
  showSelectedLocations: false,
})
export const setShowSelectedLocationGroups = () => ({
  type: SET_SHOW_SELECTED_LOCATION_GROUPS,
  showSelectedLocationGroups: true,
})
export const setHideSelectedLocationGroups = () => ({
  type: SET_SHOW_SELECTED_LOCATION_GROUPS,
  showSelectedLocationGroups: false,
})
export const setShowSelectedRoles = () => ({
  type: SET_SHOW_SELECTED_ROLES,
  showSelectedRoles: true,
})
export const setHideSelectedRoles = () => ({
  type: SET_SHOW_SELECTED_ROLES,
  showSelectedRoles: false,
})
export const setHideSelectedOrgGroups = () => ({
  type: SET_SHOW_SELECTED_ORG_GROUPS,
  showSelectedOrgGroups: false,
})
export const setShowSelectedStores = () => ({
  type: SET_SHOW_SELECTED_STORES,
  showSelectedStores: true,
})
export const setHideSelectedStores = () => ({
  type: SET_SHOW_SELECTED_STORES,
  showSelectedStores: false,
})
export const setShowFormSubmission = (payload) => ({
  type: SET_SHOW_FORM_SUBMISSION,
  payload,
})
export const setFormSubmissionId = (payload) => ({
  type: SET_FORM_SUBMISSION_ID,
})

export const setSubmissionModalData = (payload) => ({
  type: SET_SUBMISSION_MODAL_DATA,
  payload,
})

export const setFillFormModalData = (payload) => ({
  type: SET_FILL_FORM_MODAL_DATA,
  payload,
})

// Section-related actions
export const createSection = (sectionData) => {
  return (dispatch, getState) => {
    return AxiosInstance.post('/forms/sections', sectionData).then(
      (response) => {
        dispatch(fetchForms()) // Refresh forms list
      }
    )
  }
}

export const updateSection = (sectionId, sectionData) => {
  return (dispatch, getState) => {
    return AxiosInstance.put(`/forms/sections/${sectionId}`, sectionData).then(
      (response) => {
        dispatch(fetchForms()) // Refresh forms list
      }
    )
  }
}
